/** 都道府県 */
export const PrefectureCd = {
  hokkaido: 'hokkaido',
  aomoriken: 'aomoriken',
  iwateken: 'iwateken',
  miyagiken: 'miyagiken',
  akitaken: 'akitaken',
  yamagataken: 'yamagataken',
  fukushimaken: 'fukushimaken',
  ibarakiken: 'ibarakiken',
  tochigiken: 'tochigiken',
  gunmaken: 'gunmaken',
  saitamaken: 'saitamaken',
  chibaken: 'chibaken',
  tokyoto: 'tokyoto',
  kanagawaken: 'kanagawaken',
  niigataken: 'niigataken',
  toyamaken: 'toyamaken',
  ishikawaken: 'ishikawaken',
  fukuiken: 'fukuiken',
  yamanashiken: 'yamanashiken',
  naganoken: 'naganoken',
  gifuken: 'gifuken',
  shizuokaken: 'shizuokaken',
  aichiken: 'aichiken',
  mieken: 'mieken',
  shigaken: 'shigaken',
  kyotohu: 'kyotohu',
  osakahu: 'osakahu',
  hyogoken: 'hyogoken',
  naraken: 'naraken',
  wakayamaken: 'wakayamaken',
  tottoriken: 'tottoriken',
  shimaneken: 'shimaneken',
  okayamaken: 'okayamaken',
  hiroshimaken: 'hiroshimaken',
  yamaguchiken: 'yamaguchiken',
  tokushimaken: 'tokushimaken',
  kagawaken: 'kagawaken',
  ehimeken: 'ehimeken',
  kochiken: 'kochiken',
  fukuokaken: 'fukuokaken',
  sagaken: 'sagaken',
  nagasakiken: 'nagasakiken',
  kumamotoken: 'kumamotoken',
  oitaken: 'oitaken',
  miyazakiken: 'miyazakiken',
  kagoshimaken: 'kagoshimaken',
  okinawaken: 'okinawaken',
  other: 'other',
} as const;

/** 業種 */
export const SectorCd = {
  software: 'software',
  telecommunication: 'telecommunication',
  internet: 'internet',
  generalElectronics: 'general_electronics',
  computer: 'computer',
  electronicComponents: 'electronic_components',
  precisionMachinery: 'precision_machinery',
  machine: 'machine',
  car: 'car',
  medicalEquipment: 'medical_equipment',
  metal: 'metal',
  pharmaceuticals: 'pharmaceuticals',
  foodstuff: 'foodstuff',
  generalTrading: 'general_trading',
  consultant: 'consultant',
  advertising: 'advertising',
  design: 'design',
  events: 'events',
  construction: 'construction',
  Infrastructure: 'Infrastructure',
  transportation: 'transportation',
  retail: 'retail',
  finance: 'finance',
  education: 'education',
  healthcare: 'healthcare',
  welfare: 'welfare',
  deviceManufacturing: 'device_manufacturing',
  other: 'other',
} as const;

/** 職種 */
export const OccupationCd = {
  designer: 'designer',
  markup: 'markup',
  programmer: 'programmer',
  frontend: 'frontend',
  backend: 'backend',
  system: 'system',
  software: 'software',
  mobile: 'mobile',
  infra: 'infra',
  network: 'network',
  database: 'database',
  security: 'security',
  iot: 'iot',
  control: 'control',
  builtin: 'builtin',
  pm: 'pm',
  pmo: 'pmo',
  pl: 'pl',
  tester: 'tester',
  debugger: 'debugger',
  supporter: 'supporter',
  sales: 'sales',
  marketer: 'marketer',
  consultant: 'consultant',
  researcher: 'researcher',
  quality: 'quality',
  web: 'web',
  embedded: 'embedded',
  customer: 'customer',
  support: 'support',
  webdesigner: 'webdesigner',
  bridge: 'bridge',
  webmarketer: 'webmarketer',
  data: 'data',
  operation: 'operation',
  sre: 'sre',
  server: 'server',
  other: 'other',
} as const;

/** 性別 */
export const GenderCd = {
  male: 'male',
  female: 'female',
  other: 'other',
  none: 'none',
} as const;

/** 単価単位区分 */
export const PaymentUnitDivisionCd = {
  hour: 'hour',
  month: 'month',
  week: 'week',
  day: 'day',
  performance: 'performance',
  year: 'year',
} as const;

/** スキル */
export const SkillCd = {
  java: 'java',
  spring: 'spring',
  javaee: 'javaee',
  play: 'play',
  spark: 'spark',
  struts: 'struts',
  struts2: 'struts2',
  wicket: 'wicket',
  hibernate: 'hibernate',
  grails: 'grails',
  vaadin: 'vaadin',
  php: 'php',
  laravel: 'laravel',
  fuel: 'fuel',
  symfony: 'symfony',
  cake: 'cake',
  codeigniter: 'codeigniter',
  phalcon: 'phalcon',
  zend: 'zend',
  flight: 'flight',
  silex: 'silex',
  ice: 'ice',
  ethna: 'ethna',
  kohana: 'kohana',
  bear: 'bear',
  yii: 'yii',
  wp: 'wp',
  ruby: 'ruby',
  rails: 'rails',
  sinatra: 'sinatra',
  cuba: 'cuba',
  ramaze: 'cuba',
  hanami: 'hanami',
  padrino: 'padrino',
  camping: 'camping',
  python: 'python',
  django: 'django',
  bottle: 'bottle',
  flask: 'flask',
  tornado: 'tornado',
  plone: 'plone',
  tensorflow: 'tensorflow',
  keras: 'keras',
  pytorch: 'pytorch',
  c: 'c',
  unity: 'unity',
  go: 'go',
  gin: 'gin',
  echo: 'echo',
  iris: 'iris',
  revel: 'revel',
  beego: 'beego',
  goji: 'goji',
  cs: 'cs',
  cpp: 'cpp',
  dart: 'dart',
  flutter: 'flutter',
  js: 'js',
  react: 'react',
  angular: 'angular',
  angularjs: 'angularjs',
  node: 'node',
  vue: 'vue',
  nuxt: 'nuxt',
  next: 'next',
  three: 'three',
  chart: 'chart',
  kotlin: 'kotlin',
  ktor: 'ktor',
  shell: 'shell',
  ecma: 'ecma',
  typescript: 'typescript',
  jscript: 'jscript',
  express: 'express',
  backbone: 'backbone',
  jquery: 'jquery',
  actionscript: 'actionscript',
  perl: 'perl',
  mojolicios: 'mojolicios',
  dancer: 'dancer',
  catalyst: 'catalyst',
  amon2: 'amon2,',
  tripletail: 'tripletail',
  ark: 'ark',
  cobol: 'cobol',
  html: 'html',
  css: 'css',
  sass: 'sass',
  bootstrap: 'bootstrap',
  less: 'less',
  coffeescript: 'coffeescript',
  objectivec: 'objectivec',
  swift: 'swift',
  rust: 'rust',
  haskell: 'haskell',
  scala: 'scala',
  yesod: 'yesod',
  tonatona: 'tonatona',
  happstack: 'happstack',
  snap: 'snap',
  miku: 'miku',
  lemmadhine: 'lemmadhine',
  mohws: 'mohws',
  salvia: 'salvia',
  scotty: 'scotty',
  miso: 'miso',
  servant: 'servant',
  mflow: 'mflow',
  spock: 'spock',
  wheb: 'wheb',
  webapi: 'webapi',
  vba: 'vba',
  perfect: 'perfect',
  swifton: 'swifton',
  slimane: 'slimane',
  kitura: 'kitura',
  swiftexpress: 'swiftexpress',
  vapor: 'vapor',
  httpswiftserver: 'httpswiftserver',
  uikit: 'uikit',
  gcp: 'gcp',
  linux: 'linux',
  nginx: 'nginx',
  apache: 'apache',
  dockerpython: 'dockerpython',
  mysql: 'mysql',
  iot: 'iot',
  lambda: 'lambda',
  postgresql: 'postgresql',
  elasticsearch: 'elasticsearch',
  oracle: 'oracle',
  sqlserver: 'sqlserver',
  docker: 'docker',
  python3: 'python3',
  fargate: 'fargate',
  aws: 'aws',
  azure: 'azure',
  jenkins: 'jenkins',
  salesforce: 'salesforce',
  firebase: 'firebase',
  googleAnalyticsSalesforcemarketoElasticsearch:
    'google analytics salesforcemarketo elasticsearch',
  googleOptimize: 'google optimize',
  photoshop: 'photoshop',
  illustrator: 'illustrator',
  clipStudio: 'clip studio',
  sketch: 'sketch',
  afterEffects: 'after effects',
  sqlite: 'sqlite',
  git: 'git',
  confluence: 'confluence',
  circleci: 'circleci',
  datadog: 'datadog',
  sentry: 'sentry',
  slack: 'slack',
  gke: 'gke',
  kubernetes: 'kubernetes',
  cloudsql: 'cloudsql',
  googleBigquer: 'google bigquer',
  pubSub: 'pub / sub',
  aerospike: 'aerospike',
  terraform: 'terraform',
  zendeskSupport: 'zendesk support',
  freshdesk: 'freshdesk',
  siObjectBrowserPm: 'si object browser pm',
  brushup: 'brushup',
  innopm: 'innopm',
  jooto: 'jooto',
  myRedmine: 'my redmine',
  taskworld: 'taskworld',
  trello: 'trello',
  wrike: 'wrike',
  zohoProjects: 'zoho projects',
  asana: 'asana',
  kintone: 'kintone',
  backlog: 'backlog',
  googleAnalyticsGoogleSearchConsoleGoogleOptimize:
    'google analytics、google search console、google optimize',
  jiraPivotalTracker: 'jira pivotal tracker',
  rakeJfrog: 'rake jfrog',
  apacheMavenXebialabs: 'apache maven xebialabs',
  terraformAnsible: 'terraform ansible',
  kubernetesMesosphere: 'kubernetes mesosphere',
  newRelic: 'new relic',
  pagespeedInsights: 'pagespeed insights',
  ptengine: 'ptengine',
  userHeat: 'user heat',
  optimizelyX: 'optimizely x',
  kaizenPlatform: 'kaizen platform',
  grc: 'grc',
  similarweb: 'similarweb',
  copycontentdetector: 'copycontentdetector',
  socialInsight: 'social insight',
  photoshopForIpad: 'photoshop for ipad',
  figma: 'figma',
  adobeXd: 'adobe xd',
  gimp: 'gimp',
  inkscape: 'inkscape',
  krita: 'krita',
  wix: 'wix',
  studio: 'studio',
  office365: 'office 365',
  ftkImagerLite: 'ftk imager lite',
  dumpit: 'dumpit',
  wireshark: 'wireshark',
  processExplorerByMicrosoft: 'process explorer(by microsoft)',
  nexposeByRapid7: 'nexpose(by rapid7)',
  tcpviewByMicrosoft: 'tcpview(by microsoft)',
  autorunsByMicrosoft: 'autoruns(by microsoft)',
  ollydbg: 'ollydbg',
  hashmyfileByNirsoft: 'hashmyfile(by nirsoft)',
  iecacheviewByNirsoft: 'iecacheview(by nirsoft)',
  logParserStudioByMicrosoft: 'log parser studio(by microsoft)',
  sigcheckByMicrosoft: 'sigcheck(by microsoft)',
  dumpsec: 'dumpsec',
  cainAndAbel: 'cain & abel',
  passwordRecoveryByElcomsoft: 'password recovery(by elcomsoft)',
  calomelSslValidator: 'calomel ssl validator',
  visualStudioByMicrosoft: 'visual studio(by microsoft)',
  circleCi: 'circle ci',
  puppeteer: 'puppeteer',
  katalonStudio: 'katalon studio',
  travisci: 'travisci',
  cypress: 'cypress',
  testcafe: 'testcafe',
  selenium: 'selenium',
  appium: 'appium',
  ques: 'ques',
  zenCoding: 'zen coding',
  emmet: 'emmet',
  clibor: 'clibor',
  tinymceTemplates: 'tinymce templates',
  getTabInfo: 'get tab info',
  mediaQueries: 'media queries',
  jfrog: 'jfrog',
  reactnative: 'reactnative',
  other: 'other',
} as const;

/**  工程CD */
export const ProcessCd = {
  require: 'require',
  externalDesign: 'external_design',
  internalDesign: 'internal_design',
  outlineDesign: 'outline_design',
  detailDesign: 'detail_design',
  develop: 'develop',
  test: 'test',
  maintenance: 'maintenance',
} as const;

/**  開発環境CD */
export const DevelopmentEnvironmentCd = {
  linux: 'linux',
  centos: 'centos',
  ubuntu: 'ubuntu',
  redhat: 'redhat',
  debian: 'debian',
  unix: 'unix',
  windows: 'windows',
  mac: 'mac',
  bsd: 'bsd',
  ios: 'ios',
  android: 'android',
  solaris: 'solaris',
  tron: 'tron',
  vxWorks: 'vx-works',
  mvs: 'mvs ',
  redhatEnterpriseLinux: 'redhat enterprise linux',
  alpineLinux: 'alpine linux',
  freebsd: 'freebsd',
  other: 'other',
} as const;

/**  期間単位CD */
export const PeriodUnitCd = {
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
} as const;

/** 資格 */
export const QualificationCd = {
  IP: 'IP',
  FE: 'FE',
  AP: 'AP',
  DB: 'DB',
  SA: 'SA',
  ES: 'ES',
  NW: 'NW',
  SC: 'SC',
  ST: 'ST',
  SM: 'SM',
  AU: 'AU',
  PM: 'PM',
  MOS: 'MOS',
  MOSE: 'MOSE',
  PMP: 'PMP',
  CCBA: 'CCBA',
  LPIC1: 'LPIC1',
  LPIC2: 'LPIC2',
  LPIC3: 'LPIC3',
  LINUC1: 'LINUC1',
  LINUC2: 'LINUC2',
  LINUC3: 'LINUC3',
  PCIDSS: 'PCI DSS',
  RISS: 'RISS',
  MTA: 'MTA',
  MCSA: 'MCSA',
  MCSE: 'MCSE',
  MCSD: 'MCSD',
  OCJP_BSE: 'OCJP_BSE',
  OCJP_BSE7_8: 'OCJP_BSE7_8',
  OCJP_SSE8: 'OCJP_SSE8',
  OCJP_GSE8: 'OCJP_GSE8',
  OCJP_SSE11: 'OCJP_SSE11',
  OCJP_GSE11: 'OCJP_GSE11',
  OMBOD11g: 'OMBOD11g',
  OMSOD11g: 'OMSOD11g',
  OMGOD11g: 'OMGOD11g',
  OMPOD11g: 'OMPOD11g',
  OMBOD12c: 'OMBOD12c',
  OMSOD12c: 'OMSOD12c',
  OMGOD12c: 'OMGOD12c',
  OMPOD12c: 'OMPOD12c',
  CCNA: 'CCNA',
  CCNP: 'CCNP',
  CCIE: 'CCIE',
  com_MASTER: 'com_MASTER',
  CS: 'CS',
  PCMC: 'PCMC',
  ITC: 'ITC',
  VBC: 'VBC',
  SECC: 'SECC',
  HTML5: 'HTML5',
  J: 'J',
  P: 'P',
  VEOS: 'VEOS',
  OSSDB: 'OSSDB',
  IC3: 'IC3',
  JPACE: 'JPACE',
  CPACE: 'CPACE',
  ABDSCE: 'ABDSCE',
  XML: 'XML',
  IPEACE: 'IPEACE',
  HPACE: 'HPACE',
  CIW: 'CIW',
  YMTP: 'YMTP',
  RACRP: 'RACRP',
  MCCP: 'MCCP',
  ITFP: 'ITFP',
  CTA: 'CTA',
  CBAS: 'CBAS',
  SEO: 'SEO',
  DTC: 'DTC',
  MCT: 'MCT',
  PCIC: 'PCIC',
  SEC: 'SEC',
  ITPS: 'ITPS',
  JCPCC: 'JCPCC',
  JCPC: 'JCPC',
  CAD: 'CAD',
  TCADS: 'TCADS',
  WAT: 'WAT',
  CTE: 'CTE',
  SIAM: 'SIAM',
  DEVOPS: 'DEVOPS',
  ASF: 'ASF',
  SNSEC: 'SNSEC',
  IST: 'IST',
  ACE: 'ACE',
  MSTC: 'MSTC',
  IOT: 'IOT',
  IOTSTC: 'IOTSTC',
  JASA: 'JASA',
  SMC: 'SMC',
  MTBC: 'MTBC',
  JCSQE: 'JCSQE',
  ASDE: 'ASDE',
  ESSE: 'ESSE',
  WDST: 'WDST',
  ISM: 'ISM',
  SW: 'SW',
  SU: 'SU',
  SD: 'SD',
  AD: 'AD',
  ME: 'ME',
  PE: 'PE',
  LPIC: 'LPIC',
  CMC: 'CMC',
  ESPS: 'ESPS',
  ABD: 'ABD',
  JPC: 'JPC',
  PPC: 'PPC',
  OCJ: 'OCJ',
  OMS: 'OMS',
  IRAA: 'IRAA',
  IPEC: 'IPEC',
  CTSE: 'CTSE',
  WDS: 'WDS',
  WDT: 'WDT',
  ICAT: 'ICAT',
  PCAT: 'PCAT',
  CGC: 'CGC',
  CDE: 'CDE',
  CGA: 'CGA',
  DTP: 'DTP',
  MCPCM: 'MCPCM',
  RACS: 'RACS',
  HPCT: 'HPCT',
  NPCCB: 'NPCCB',
  NPCDB: 'NPCDB',
  SXF: 'SXF',
  IPEL1: 'IPEL1',
  MCPCS: 'MCPCS',
  BK: 'BK',
  LPIC102: 'LPIC102',
  LPIC101: 'LPIC101',
  DPATS1: 'DPATS1',
  DPATW1: 'DPATW1',
  CIQE1: 'CIQE1',
  RACG: 'RACG',
  WDT1: 'WDT1',
  EST: 'EST',
  CADB: 'CADB',
  JSP: 'JSP',
  JSS: 'JSS',
  CADTIM: 'CADTIM',
  CADTAM: 'CADTAM',
  XMLM: 'XMLM',
  CST1: 'CST1',
  JPACT2: 'JPACT2',
  JIU1: 'JIU1',
  JIS: 'JIS',
  DIM1: 'DIM1',
  CADCA: 'CADCA',
  CAD3T: 'CAD3T',
  CAD3A: 'CAD3A',
  EFTB: 'EFTB',
  CTN: 'CTN',
  VBAEB: 'VBAEB',
  VBAAB: 'VBAAB',
  PCS1: 'PCS1',
  FDC2: 'FDC2',
  MIDI2: 'MIDI2',
  CPS2: 'CPS2',
  OCJPB: 'OCJPB',
  JPS1: 'JPS1',
  SEAJC: 'SEAJC',
  CTCE: 'CTCE',
  EFTA: 'EFTA',
  FDC1: 'FDC1',
  MIDI1: 'MIDI1',
  SEAJCM: 'SEAJCM',
  CPS1: 'CPS1',
  MCPC1: 'MCPC1',
  CTS: 'CTS',
  ITCA: 'ITCA',
  NPCDC1: 'NPCDC1',
  NPCPC1: 'NPCPC1',
  NPCD1: 'NPCD1',
  CAD3D1: 'CAD3D1',
  CAD1M: 'CAD1M',
  CAD1A: 'CAD1A',
  CAD1T: 'CAD1T',
  ACPB: 'ACPB',
  ACAB: 'ACAB',
  OMSS: 'OMSS',
  CISA: 'CISA',
  SEAJCT: 'SEAJCT',
  CISM: 'CISM',
  OCJP: 'OCJP',
  OSSDBG: 'OSSDBG',
  ACAP: 'ACAP',
  ISC: 'ISC',
  XMPD: 'XMPD',
  XMPA: 'XMPA',
  OCJPG: 'OCJPG',
  NM: 'NM',
  AWSC: 'AWSC',
  AE: 'AE',
  RTXV: 'RTXV',
  OMP: 'OMP',
  DP3: '3DP',
  SDT: 'SDT',
  TTT: 'TTT',
  AIT: 'AIT',
  JT: 'JT',
  OPCEL: 'OPCEL',
  ISS: 'ISS',
  GCPCA: 'GCPCA',
  AWSAA: 'AWSAA',
  CRISC: 'CRISC',
  CISSP: 'CISSP',
  CISAA: 'CISAA',
  AWSCP: 'AWSCP',
  ITIL: 'ITIL',
  MCAF: 'MCAF',
  MCAAA: 'MCAAA',
  CCAN: 'CCAN',
  CRS: 'CRS',
  CCPV: 'CCPV',
} as const;

/** 候補者流入元CD*/
export const InflowSourceCd = {
  application: 1,
  scout: 2,
} as const;

/** 候補者ステータス*/
export const CandidateStatus = {
  waiting: 'waiting',
  working: 'working',
  completed: 'completed',
  pending: 'pending',
  stopped: 'stopped',
} as const;

/** 並び順 */
export const Sort = {
  new: 'new', // 登録日時降順
  old: 'old', // 登録日時昇順
} as const;

/** 精算方法*/
export const PayType = {
  ticketUnitPrice: 1,
  scheduledTime: 2,
  actualTime: 3,
  monthly: 4,
} as const;

/** ロール */
export const RoleCd = {
  administrator: 'administrator',
  general: 'general',
  guest: 'guest',
} as const;

/** プロジェクト参画身分 */
export const ProjectMemberRelationshipCd = {
  proper: 'proper',
  freelance: 'freelance',
  ses: 'ses',
  permatemp: 'permatemp',
  parttime: 'parttime',
  intern: 'intern',
} as const;

/** アクティビティ種別 */
export const ActivityKindCd = {
  addTask: 'add_task',
  addTaskComment: 'add_task_comment',
  updateTask: 'update_task',
  chargeTask: 'charge_task',
  practiceTask: 'practice_task',
  addBranch: 'add_branch',
  pushBranch: 'push_branch',
  receiveMessage: 'receive_message',
  addPullRequest: 'add_pull_request',
  updatePullRequest: 'update_pull_request',
  chargePullRequest: 'charge_pull_request',
  addPullRequestComment: 'add_pull_request_comment',
  addMember: 'add_member',
  leaveMember: 'leave_member',
  presentShift: 'present_shift',
  permitShift: 'permit_shift',
  addConcern: 'add_concern',
  scout: 'scout',
  offerWeb: 'offer_web',
} as const;

/** 通知種別 */
export const NotificationKindCd = {
  addTaskResponsible: 'add_task_responsible',
  addTaskPractitioner: 'add_task_practitioner',
  addTaskCustom: 'add_task_custom',
  updateTaskResponsible: 'update_task_responsible',
  updateTaskPractitioner: 'update_task_practitioner',
  updateTaskCustom: 'update_task_custom',
  addTaskComment: 'add_task_comment',
  addPullRequestResponsible: 'add_pull_request_responsible',
  updatePullRequestResponsible: 'update_pull_request_responsible',
  mergePullRequest: 'merge_pull_request',
  addPullRequestComment: 'add_pull_request_comment',
  addMember: 'add_member',
  leaveMember: 'leave_member',
  presentShift: 'present_shift',
  approveShift: 'approve_shift',
  rejectShift: 'reject_shift',
  deleteShift: 'delete_shift',
  addConcern: 'add_concern',
  scout: 'scount',
} as const;

/** 通知種別ID */
export const NotificationKindId = {
  addTaskResponsible: 1,
  addTaskPractitioner: 2,
  addTaskCustom: 3,
  updateTaskResponsible: 4,
  updateTaskPractitioner: 5,
  updateTaskCustom: 6,
  addTaskComment: 7,
  addPullRequestResponsible: 8,
  updatePullRequestResponsible: 9,
  mergePullRequest: 10,
  addPullRequestComment: 11,
  addMember: 12,
  leaveMember: 13,
  presentShift: 14,
  approveShift: 15,
  rejectShift: 16,
  deleteShift: 17,
  addConcern: 18,
  scout: 19,
} as const;

/** @Transformを使う時に型が必要な場合に使う */
export type TransformType = {
  value: string | null;
  key: string | null;
  obj: { [key: string]: string };
  type: number;
  options: { [key: string]: unknown };
};

/** カラーCD */
export const ColorCd = {
  AliceBlue: 'aliceblue',
  AntiqueWhite: 'antiquewhite',
  Aqua: 'aqua',
  Aquamarine: 'aquamarine',
  Azure: 'azure',
  Beige: 'beige',
  Bisque: 'bisque',
  Black: 'black',
  BlanchedAlmond: 'blanchedalmond',
  Blue: 'blue',
  BlueViolet: 'blueviolet',
  Brown: 'brown',
  BurlyWood: 'burlywood',
  CadetBlue: 'cadetblue',
  Chartreuse: 'chartreuse',
  Chocolate: 'chocolate',
  Coral: 'coral',
  CornflowerBlue: 'cornflowerblue',
  Cornsilk: 'cornsilk',
  Crimson: 'crimson',
  Cyan: 'cyan',
  DarkBlue: 'darkblue',
  DarkCyan: 'darkcyan',
  DarkGoldenRod: 'darkgoldenrod',
  DarkGray: 'darkgray',
  DarkGrey: 'darkgrey',
  DarkGreen: 'darkgreen',
  DarkKhaki: 'darkkhaki',
  DarkMagenta: 'darkmagenta',
  DarkOliveGreen: 'darkolivegreen',
  DarkOrange: 'darkorange',
  DarkOrchid: 'darkorchid',
  DarkRed: 'darkred',
  DarkSalmon: 'darksalmon',
  DarkSeaGreen: 'darkseagreen',
  DarkSlateBlue: 'darkslateblue',
  DarkSlateGray: 'darkslategray',
  DarkSlateGrey: 'darkslategrey',
  DarkTurquoise: 'darkturquoise',
  DarkViolet: 'darkviolet',
  DeepPink: 'deeppink',
  DeepSkyBlue: 'deepskyblue',
  DimGray: 'dimgray',
  DimGrey: 'dimgrey',
  DodgerBlue: 'dodgerblue',
  FireBrick: 'firebrick',
  FloralWhite: 'floralwhite',
  ForestGreen: 'forestgreen',
  Fuchsia: 'fuchsia',
  Gainsboro: 'gainsboro',
  GhostWhite: 'ghostwhite',
  Gold: 'gold',
  GoldenRod: 'goldenrod',
  Gray: 'gray',
  Grey: 'grey',
  Green: 'green',
  GreenYellow: 'greenyellow',
  HoneyDew: 'honeydew',
  HotPink: 'hotpink',
  IndianRed: 'indianred',
  Indigo: 'indigo',
  Ivory: 'ivory',
  Khaki: 'khaki',
  Lavender: 'lavender',
  LavenderBlush: 'lavenderblush',
  LawnGreen: 'lawngreen',
  LemonChiffon: 'lemonchiffon',
  LightBlue: 'lightblue',
  LightCoral: 'lightcoral',
  LightCyan: 'lightcyan',
  LightGoldenRodYellow: 'lightgoldenrodyellow',
  LightGray: 'lightgray',
  LightGrey: 'lightgrey',
  LightGreen: 'lightgreen',
  LightPink: 'lightpink',
  LightSalmon: 'lightsalmon',
  LightSeaGreen: 'lightseagreen',
  LightSkyBlue: 'lightskyblue',
  LightSlateGray: 'lightslategray',
  LightSlateGrey: 'lightslategrey',
  LightSteelBlue: 'lightsteelblue',
  LightYellow: 'lightyellow',
  Lime: 'lime',
  LimeGreen: 'limegreen',
  Linen: 'linen',
  Magenta: 'magenta',
  Maroon: 'maroon',
  MediumAquaMarine: 'mediumaquamarine',
  MediumBlue: 'mediumblue',
  MediumOrchid: 'mediumorchid',
  MediumPurple: 'mediumpurple',
  MediumSeaGreen: 'mediumseagreen',
  MediumSlateBlue: 'mediumslateblue',
  MediumSpringGreen: 'mediumspringgreen',
  MediumTurquoise: 'mediumturquoise',
  MediumVioletRed: 'mediumvioletred',
  MidnightBlue: 'midnightblue',
  MintCream: 'mintcream',
  MistyRose: 'mistyrose',
  Moccasin: 'moccasin',
  NavajoWhite: 'navajowhite',
  Navy: 'navy',
  OldLace: 'oldlace',
  Olive: 'olive',
  OliveDrab: 'olivedrab',
  Orange: 'orange',
  OrangeRed: 'orangered',
  Orchid: 'orchid',
  PaleGoldenRod: 'palegoldenrod',
  PaleGreen: 'palegreen',
  PaleTurquoise: 'paleturquoise',
  PaleVioletRed: 'palevioletred',
  PapayaWhip: 'papayawhip',
  PeachPuff: 'peachpuff',
  Peru: 'peru',
  Pink: 'pink',
  Plum: 'plum',
  PowderBlue: 'powderblue',
  Purple: 'purple',
  RebeccaPurple: 'rebeccapurple',
  Red: 'red',
  RosyBrown: 'rosybrown',
  RoyalBlue: 'royalblue',
  SaddleBrown: 'saddlebrown',
  Salmon: 'salmon',
  SandyBrown: 'sandybrown',
  SeaGreen: 'seagreen',
  SeaShell: 'seashell',
  Sienna: 'sienna',
  Silver: 'silver',
  SkyBlue: 'skyblue',
  SlateBlue: 'slateblue',
  SlateGray: 'slategray',
  SlateGrey: 'slategrey',
  Snow: 'snow',
  SpringGreen: 'springgreen',
  SteelBlue: 'steelblue',
  Tan: 'tan',
  Teal: 'teal',
  Thistle: 'thistle',
  Tomato: 'tomato',
  Turquoise: 'turquoise',
  Violet: 'violet',
  Wheat: 'wheat',
  White: 'white',
  WhiteSmoke: 'whitesmoke',
  Yellow: 'yellow',
  YellowGreen: 'yellowgreen',
} as const;

/** 属性CD */
export const AttributeCd = {
  category: 'category',
  priority: 'priority',
  status: 'status',
  attribute1: 'attribute1',
  attribute2: 'attribute2',
  attribute3: 'attribute3',
  attribute4: 'attribute4',
  attribute5: 'attribute5',
  attribute6: 'attribute6',
  attribute7: 'attribute7',
  attribute8: 'attribute8',
  attribute9: 'attribute9',
  attribute10: 'attribute10',
  attribute11: 'attribute11',
  attribute12: 'attribute12',
  attribute13: 'attribute13',
  attribute14: 'attribute14',
  attribute15: 'attribute15',
  attribute16: 'attribute16',
  attribute17: 'attribute17',
  attribute18: 'attribute18',
  attribute19: 'attribute19',
  attribute20: 'attribute20',
  attribute21: 'attribute21',
  attribute22: 'attribute22',
  attribute23: 'attribute23',
  attribute24: 'attribute24',
  attribute25: 'attribute25',
  attribute26: 'attribute26',
  attribute27: 'attribute27',
  attribute28: 'attribute28',
  attribute29: 'attribute29',
  attribute30: 'attribute30',
} as const;

/**  求人案件ステータス*/
export const JobAdvertisementStatus = {
  Recruiting: 'recruiting', // 募集中
  StopRecruiting: 'stop-recruiting', // 募集停止中
  Draft: 'draft', // 下書き
} as const;

/** 属性形式 */
export const ATTRIBUTE_STYLE = {
  DATE: 'date',
  PERSON: 'person',
  TEXT: 'text',
  OPTION: 'option',
  NUMBER: 'number',
} as const;

/** 属性表示形式 */
export const ATTRIBUTE_DISPLAY_STYLE = {
  TILE: 'tile',
  BELT: 'belt',
  ACCENT: 'accent',
  COMBO: 'combo',
  RADIO: 'radio',
} as const;

/**組織課金プラン */
export const ORGANIZATION_BILLING_PLAN = {
  FREE: 'free',
  STANDARD: 'standard',
  BUSINESS: 'business',
  ENTERPRISE: 'enterprise',
  ENTERPRISE_PREMIUM: 'enterprise_premium',
} as const;

/**プラン制限 */
export const PLAN_LIMIT = {
  FREE: {
    ORGANIZATION_MEMBER: 5,
    PROJECT: 1,
  },
  STANDARD: {
    ORGANIZATION_MEMBER: 50,
    PROJECT: 10,
  },
} as const;

/**組織更新モード */
export const OrganizationUpdateMode = {
  all: 'all',
  part: 'part',
} as const;
